export default "__VITE_ASSET__0ad23677__"